import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useTestDomainStatus(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation<"post", "/shops/{shopId}/preferences/notifications/domains/check-status", void>(
    "post",
    "/shops/{shopId}/preferences/notifications/domains/check-status",
    {
      invalidate: invalidateShop,
      notify: { success: false },
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}
